import { ApiResponse, PaginatedCollection, directusApi } from '@/api';
import { asyncForEach } from '@/utils';
import lodash, { map } from 'lodash';
import moment from 'moment-timezone';
import * as XLSX from 'xlsx';
import products from './products';

export interface Ecommerce {
    id: string;
    title: string;
    products: Array<any>;
    status:boolean;
}

export interface EcommerceDTO {
    title: string;
}

export interface EcommerceState {
    activeEcommerce: Ecommerce | null;
    activeEcommerceLoading: boolean;

    allEcommerce: Array<Ecommerce>;
    allEcommerceLoading: boolean;
    ecommercePerPage: number;
    ecommercePage: number;
    ecommerceTotal: number;
}

const defaultEcommerce = {
    id: '',
    title: '',
    products: [],
    status: false,
}

const state: EcommerceState = {
    activeEcommerce: defaultEcommerce,
    activeEcommerceLoading: false,

    allEcommerce: [],
    allEcommerceLoading: false,
    ecommercePerPage: 1,
    ecommercePage: 1,
    ecommerceTotal: 1,
};

const mutations = {
    TOGGLE_ALL_ECOMMERCE_LOADING(state: EcommerceState, data: boolean) {
        state.allEcommerceLoading = data;
    },
    SET_ALL_ECOMMERCE(state: EcommerceState, data: PaginatedCollection) {
        state.allEcommerce = data.items;
        state.ecommercePerPage = data.perPage;
        state.ecommercePage = data.currentPage;
        state.ecommerceTotal = data.totalItems;
    },
    TOGGLE_ACTIVE_ECOMMERCE_LOADING(state: EcommerceState, data: boolean) {
        state.activeEcommerceLoading = data;
    },
    SET_ACTIVE_ECOMMERCE(state: EcommerceState, data: Ecommerce) {
        if (data.id) {
            let allEcommerce = [data, ...state.allEcommerce];
            state.allEcommerce = lodash.uniqBy(allEcommerce, 'id');
            state.activeEcommerce = data;
        } else {
            state.activeEcommerce = data;
        }
    },
};

const actions = {

    async postOne({ _, commit, dispatch }: any, { ecommerce }: any) {
        commit('TOGGLE_ACTIVE_ECOMMERCE_LOADING', true);

        let ecommerceEndpoint: string = 'items/ecommerce';
        let ecommerceMethod: any = 'POST';

        if (ecommerce.data.id != 0) {
            ecommerceMethod = 'PATCH';
            ecommerceEndpoint = `items/ecommerce/${ecommerce.data.id}`;
        }

        await directusApi(ecommerceMethod, ecommerceEndpoint, {
            title: ecommerce.data.title,
            status: ecommerce.data.status,
            products: ecommerce.data.products,
        })
            .then(async (ecommerceRes: any) => {
                commit('TOGGLE_ACTIVE_ECOMMERCE_LOADING', false);
                dispatch('getAll', { page: 1 });
                ecommerce.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                    title: `Obteniendo información`,
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
                commit('SET_ACTIVE_ECOMMERCE', ecommerceRes.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ACTIVE_ECOMMERCE_LOADING', false);
            });

    },
   
    async getAll({ _, commit }: any, {}: any) {
        commit('TOGGLE_ALL_ECOMMERCE_LOADING', true);
        
        let endpoint = `items/ecommerce`;
        await directusApi('GET', endpoint)
            .then(res => {
                commit('SET_ALL_ECOMMERCE', {
                    items: res.data.data,
                    perPage: 0,
                    currentPage: 1,
                    totalItems: 0,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ALL_ECOMMERCE_LOADING', false);
            });
    },

    async getOne({ _, commit }: any, id: any | null = null) {
        commit('TOGGLE_ACTIVE_ECOMMERCE_LOADING', true);
        if (id != null) {
            await directusApi('GET', `items/ecommerce/${id}`)
                .then(res => {
                    commit('SET_ACTIVE_ECOMMERCE', res.data.data);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    commit('TOGGLE_ACTIVE_ECOMMERCE_LOADING', false);
                });
        } else {
            commit('SET_ACTIVE_ECOMMERCE', defaultEcommerce);
            commit('TOGGLE_ACTIVE_ECOMMERCE_LOADING', false);
        }
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
